import React, {
  useCallback,
  FC,
}                                from 'react';
import { RouteComponentProps }   from 'react-router-dom';
import { withWidth, WithWidth }  from '@material-ui/core';
import { EAppPage }              from '@enums/common';
import {
  ENationalAdPage,
  ENationalAdSubpage,
}                                from '@enums/nationalAdManagement';
import { TopComponent }          from '@modules/nationalAdManager/components/TopComponent';
import { AdsListContainer }      from '@modules/nationalAdManager/containers/AdsListContainer';
import { AdEditorContainer }     from '@modules/nationalAdManager/containers/AdEditorContainer';
import { BannerEditorContainer } from '@modules/nationalAdManager/containers/BannerEditorContainer';

interface IParams {
  id?      : string;
  page     : ENationalAdPage;
  subpage? : ENationalAdSubpage;
}

const NationalAdManager: FC<WithWidth & RouteComponentProps<IParams>> = ({
  width,
  match: {
    params: {
      id,
      page = ENationalAdPage.cards,
      subpage,
    },
  },
  history:{
    push,
  },
}) => {
  const onCancelEdit = useCallback(
    (): void => {
      push(`${EAppPage.NationalAdManager}/${ENationalAdPage.cards}`);
    },
    [push],
  );

  return (
    <>
      <TopComponent
        push    = {push}
        width   = {width}
        page    = {page}
        subpage = {subpage}
      />

      {page === ENationalAdPage.cards && !subpage && (
        <AdsListContainer
          width = {width}
          push  = {push}
        />
      )}

      {page === ENationalAdPage.cards && !!subpage && (
        <AdEditorContainer
          width        = {width}
          id           = {id}
          onCancelEdit = {onCancelEdit}
        />
      )}

      {page === ENationalAdPage.banner && (
        <BannerEditorContainer
          width        = {width}
          onCancelEdit = {onCancelEdit}
        />
      )}
    </>
  );
};

export const NationalAdManagerContainer = withWidth()(NationalAdManager);
